<template>
  <div>
    <EventDetails
      :event-permalink="$route.params.special"
      is-giftcard
      is-special-giftcard
    ></EventDetails>
  </div>
</template>

<script setup>
definePageMeta({
  // name: 'event-details-giftcard-page', // explicit naming requires needs more attention with localization
  layout: 'default-max-screen',
  contentGroup: 'giftcard',
  allowOnPartnerPage: true,
  preloaderType: 'eventDetail',
})
</script>
